import { userService } from '../services';
import { router } from '../router';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        commit('loginRequest', { username });
        console.log("kliče se login???");
        dispatch('users/clearLoggedIn','',{ root: true });
        userService.login(username, password)
            .then(
                user => {
                    console.log(this);
                    commit('loginSuccess', user);
                    dispatch('users/getMenu','',{ root: true });
                    dispatch('users/getLoggedIn','',{ root: true });
                    router.push('/');
                },
                error => {
                   
                    commit('loginFailure', error);
                     console.log(error);
                    dispatch('alert/error', "Prijava ni uspela", { root: true });
                }
            );
    },
    logout({ dispatch, commit }) {
        userService.logout();
        commit('logout');
         console.log("kliče se logout???");
        dispatch('users/clearLoggedIn', '',{ root: true });
    },
    register({ dispatch, commit }, user) {
        commit('registerRequest', user);
    
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    router.push('/login');
                    setTimeout(() => {
                        // display success message after route change completes
                        dispatch('alert/success', 'Registration successful', { root: true });
                    })
                },
                error => {
                    console.log(error);
                    commit('registerFailure', error);
                    
                    dispatch('alert/error', "Napaka pri registraciji", { root: true });
                }
            );
    }
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state, user) {
        state.status = { registering: true };
    },
    registerSuccess(state, user) {
        state.status = {};
    },
    registerFailure(state, error) {
        state.status = {};
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};